import {createSinglePathSVG} from './TEMPLATE'

export const Strikethrough_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M5 13.3333C5 15.1743 6.49238 16.6667 8.33333 16.6667H11.6667C13.5076 16.6667 15 15.1743 15 13.3333C15 11.4924 13.5076 10 11.6667 10M8.75 16.6667C10.5909 16.6667 12.0833 15.1743 12.0833 13.3333C12.0833 11.4924 10.5909 10 8.75 10M15 6.66667C15 4.82572 13.5076 3.33333 11.6667 3.33333H8.33333C6.49238 3.33333 5 4.82572 5 6.66667M11.25 3.33333C9.40905 3.33333 7.91667 4.82572 7.91667 6.66667M2.5 10H17.5',
})
